import React, { useState } from 'react';
import { Row, Col, Form, FormGroup, Label, Input, Button, Card, CardBody, CardTitle, Container } from "reactstrap";

export default function Category() {

    const API_URL = process.env.REACT_APP_APIURL

    const [category, setCategory] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        //  console.log("Submitted Category:", category);

        const data = {
            category: category
        }

        try {
            const res = await fetch(`${`https://api.myhappywheels.com/api`}/category`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            })
            if (res.status === 200) {
                alert("Done")
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <CardTitle className="mb-4">Add Category</CardTitle>
                                    <Row>
                                        <Col md="6">
                                            <Form onSubmit={handleSubmit}>
                                                <FormGroup>
                                                    <Label className="form-label">Category</Label>
                                                    <Input
                                                        type="text"
                                                        placeholder="Enter category name"
                                                        value={category}
                                                        onChange={(e) => setCategory(e.target.value)}
                                                    />
                                                </FormGroup>
                                                <Button color="primary" type="submit">Submit</Button>
                                            </Form>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
}
